import type { z } from 'zod';

import type { VideoCategorySchema, VideoCategoryTopicSchema } from './schemas';

type VideoCategoryField = keyof z.infer<typeof VideoCategorySchema>;
type VideoCategoryTopicField = keyof z.infer<typeof VideoCategoryTopicSchema>;

const listAttributes = [
  'id',
  'subject',
  'code',
  'label',
  'shortLabel',
  'topics',
] as const satisfies readonly VideoCategoryField[];

const getAttributes = [...listAttributes] as const satisfies readonly VideoCategoryField[];

const updateAttributes = [
  'label',
  'shortLabel',
  'topics',
] as const satisfies readonly VideoCategoryField[];

const updateTopicAttributes = [
  'label',
  'shortLabel',
  'resources',
  'videos',
] as const satisfies readonly VideoCategoryTopicField[];

export const VideoCategoryAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
  UpdateTopic: updateTopicAttributes,
};
